import React, { ReactNode } from 'react';
import {
  Role,
  hasOneOfOrgRoles,
  hasOneOfGlobalRoles,
} from '../../contexts/AuthProvider/types';
import { useAuthUser } from '../../contexts/AuthProvider/hooks';

interface Props {
  roles: Role[];
  children: ReactNode;
  org?: string;
  globalOnly?: boolean;
}

const VisibleToRoles = (props: Props) => {
  const { roles, children, globalOnly, org } = props;
  const { authUser } = useAuthUser();

  if (globalOnly && hasOneOfGlobalRoles(authUser, roles)) {
    return <>{children}</>;
  } else if (
    !globalOnly &&
    (hasOneOfGlobalRoles(authUser, roles) ||
      hasOneOfOrgRoles(authUser, org ? [org] : authUser.selectedOrgs, roles))
  ) {
    return <>{children}</>;
  }
  return null;
};

export default VisibleToRoles;
